<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <header class="header">
      <div class="header-top">
        <div class="inner">
          <div class="header-left">
            <p class="site-title">
              <img src="@/assets/images/TDSDC/logo_tatsuzin.png" width="88" height="21" alt="TATSUZIN" />
            </p>
          </div>
        </div>
      </div>
    </header>
    <br />
    <!-- ****  メッセージ表示領域 **** -->
    <div class="inner-errMsg">
      <p class="errMsg aligncenter newline" style="color: black;" id="outMessageArea">{{ errMsg }}</p>
    </div>
    <div class="inner-errMsg-btn">
      <button class="frm-btn strong large" type="button" style="width:100%;" @click="handleReLogin"
       v-if="loginSide != ''"  >こちらより、再ログインしてください
      </button>
    </div>
   
  </div>
</template>

<script>
import { API_Signout, API_BopSignout, API_GetBasicInfo } from '@/api/Modules/CM04/STDSCM04C00.js'
import Common from "@/util/common.js";
export default {
  name: "STDSCM04C06VariousErrors",
  data() {
    return {
      errMsg: "",
      loginSide: "",
      EnumLoginSide: {
        account: 1, // 税理士事務所
        business: 2, // 事業者
      },
    };
  },
  created() {
    this.errMsg = history.state?.message;
  },
  mounted() {
    const tabId = sessionStorage.getItem('istabId');
    if (!tabId) {
      // **********************************************
      // ログアウト
      // **********************************************
      API_Signout().then((accountRes) => {
        API_BopSignout().then((businessRes) => {
          // 基本情報取得できる
          if (this.$cookies.get('isBopLogin') == 'true') {
            this.loginSide = this.EnumLoginSide.business;           
          } else {
            this.loginSide = this.EnumLoginSide.account;
          }
        });
      });
    } else {
      sessionStorage.removeItem("istabId");
    }
  },
  methods: {
    // **********************************************
    // 再ログイン
    // **********************************************
    handleReLogin() {
      if (this.loginSide == this.EnumLoginSide.account) {
        // 税理士事務所ログイン画面に遷移
        this.$redirect({ name: "STDSCM01C01", state: { reload: "reload" } });
      } else {
        // 事業者ログイン画面に遷移
        let url = Common.getSettingsValue("BopPortalLoginUrl");
        window.location.href = `${url}`;
      }
    },
  },
};
</script>

<style scoped>
p {
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1280px) {
  .inner-errMsg-btn {
    margin: 15px auto;
    max-width: 320px;
    min-width: 320px;
  }

  .inner {
    margin: 0 auto;
    max-width: unset;
    min-width: unset;
  }

  .inner-errMsg {
    margin: 0px auto;
    padding-top: 85px;
    max-width: 320px;
    min-width: 320px;
  }
}
</style>
